module.exports = __webpack_public_path__ + "img/note.1d5d39a5.png";